/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const DropdownIndicator = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.DropdownIndicator {...otherProps} className={className}>
      {children}
    </components.DropdownIndicator>
  );
};

DropdownIndicator.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

DropdownIndicator.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default DropdownIndicator;
